import React from 'react'
import styled from 'styled-components'

import { Content } from '../../../../layouts'
// import { useMotesCountQuery } from '@mote/api'

// function getMotesCountFromStorageOrDefault() {
//   const motesCount = window.localStorage.getItem('mote-motes-count')
//
//   if (motesCount) {
//     return parseInt(motesCount)
//   }
//   return 31055312
// }

// const numberFormat = new Intl.NumberFormat()

export const BenefitsSection = () => {
  // const { data } = useMotesCountQuery()

  // const count = React.useMemo(() => {
  //   if (!data) {
  //     const motesCount = getMotesCountFromStorageOrDefault()
  //
  //     return numberFormat.format(motesCount)
  //   }
  //
  //   window.localStorage.setItem('mote-motes-count', data?.motesCount)
  //
  //   return numberFormat.format(data?.motesCount)
  // }, [data])

  return (
    <Root>
      <Content>
        {/* <BusinessSummary>
      Connect your organization and accelerate productivity with Mote, the new way for distributed teams to communicate. 
      <br></br>
      Integrated within the apps you already use, Mote allows for easy voice messaging for team collaboration, online learning and much more.
          </BusinessSummary> */}
        {/* <StatisticsContainer>
          <NumberOfMotesCreated>
            🚀 {count} motes created to date!
          </NumberOfMotesCreated>
          <NumberOfUsers>
            Join over 1 million users already moting a difference
          </NumberOfUsers>
        </StatisticsContainer> */}

        <Benefits>
          <Benefit>
            <ImageContainer>
              <span>💨</span>
            </ImageContainer>
            <Title>Mote saves you time</Title>
            <Subtitle>
              Talking is 3x faster than typing - Mote users save hours every
              week
            </Subtitle>
          </Benefit>
          <Benefit>
            <ImageContainer>
              <span>💜</span>
            </ImageContainer>
            <Title>Mote helps you connect</Title>
            <Subtitle>
              Your voice conveys your energy, intent and empathy far better than
              text
            </Subtitle>
          </Benefit>
          <Benefit>
            <ImageContainer>
              <span>🌍</span>
            </ImageContainer>
            <Title>Mote is accessible</Title>
            <Subtitle>
              With audio, voice-to-text and translation, Mote is accessible to
              all
            </Subtitle>
          </Benefit>
        </Benefits>
      </Content>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 96px 0;

  @media (max-width: 1199px) {
    padding: 60px 0;
  }

  @media (max-width: 991px) {
    padding: 40px 0;
  }
  @media (max-width: 639px) {
    padding: 40px 0;
  }
`
// const BusinessSummary = styled.h4`
//   flex: 0 0 430px;
//   margin-right: 41px;
//   font-style: normal;
//   font-size: 24px;
//   line-height: 140%;
//   text-align: left;
//   letter-spacing: -0.05em;
//   color: #232323;
//   margin-bottom: 80px;

//   @media (max-width: 1199px) {
//     margin-bottom: 60px;
//   }

//   @media (max-width: 991px) {
//     margin-bottom: 48px;
//   }

//   @media (max-width: 639px) {
//     margin-bottom: 32px;
//   }
// `
// const StatisticsContainer = styled.div``
// const NumberOfMotesCreated = styled.h5`
//   font-style: normal;
//   font-weight: bold;
//   font-size: 18px;
//   line-height: 120%;
//   text-align: center;
//   letter-spacing: -0.05em;
//   color: #232323;
//   margin-bottom: 16px;
// `
// const NumberOfUsers = styled.h3`
//   font-style: normal;
//   font-weight: bold;
//   font-size: 32px;
//   line-height: 120%;
//   text-align: center;
//   letter-spacing: -0.05em;
//   color: #232323;
//   margin-bottom: 80px;

//   @media (max-width: 1199px) {
//     margin-bottom: 60px;
//   }

//   @media (max-width: 991px) {
//     margin-bottom: 48px;
//   }

//   @media (max-width: 639px) {
//     margin-bottom: 32px;
//   }
// `
const Benefits = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 639px) {
    flex-direction: column;
    align-items: center;
  }
`
const Benefit = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 333px;
`
const ImageContainer = styled.div`
  width: 130px;
  height: 130px;
  background: #f9f9fb;
  display: grid;
  place-items: center;
  border-radius: 50%;
  margin-bottom: 32px;

  span {
    font-size: 65px;
  }

  @media (max-width: 1199px) {
    width: 110px;
    height: 110px;
  }

  @media (max-width: 639px) {
    width: 90px;
    height: 90px;
    margin: 40px 0 32px 0;
  }
`
const Title = styled.p`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.05em;
  color: #232323;
`
const Subtitle = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 150%;
  text-align: center;
  color: #232323;
`
